export default __webpack_public_path__ + "static/media/menu3.e19a41ec.jpg";